
import Vue, {PropOptions} from 'vue';


export default Vue.extend({
  props: {
    size: {
      type: String,
      required: false,
      default: 'base',
    } as PropOptions<'base' | 'small' | 'smaller'>
  }
})
